import moduleDescriptions from 'root/src/shared/descriptions/modules'
import { listModuleLenses } from 'root/src/client/logic/list/lenses'

const { viewScrollItemBreakpoints } = listModuleLenses

export default (state, { moduleId }) => viewScrollItemBreakpoints(moduleId, moduleDescriptions)
